export default {
  main: '#d9c7a6',
  secondary: '#205C40',
  contrastingColor: '#000000',
  priceColor: '#d9c7a6',
  entryBackground: '#d9c7a6',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
